module.exports = __webpack_public_path__ + "img/4.dbaae5e0.png";